import { render, staticRenderFns } from "./ProductColorAndCount.vue?vue&type=template&id=44ef3338&scoped=true&"
import script from "./ProductColorAndCount.vue?vue&type=script&lang=js&"
export * from "./ProductColorAndCount.vue?vue&type=script&lang=js&"
import style0 from "./ProductColorAndCount.vue?vue&type=style&index=0&id=44ef3338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef3338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VSelect})
